module.exports = {"152201001":"爱国","152201002":"和平","152201003":"兴安","152201004":"胜利","152201005":"铁西","152201006":"都林","152201007":"五一","152201008":"城郊","152201100":"乌兰哈达镇","152201101":"葛根庙镇","152201102":"太本站镇","152201103":"义勒力特镇","152201401":"呼和马场","152201402":"乌兰浩特工业经济开发区","152201403":"乌兰浩特经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152201.json
// module id = 431
// module chunks = 0